// ADDED
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Input } from "../../../../../common/Input";

const DTRItineraryAddEditModal = ({ isOpen, onClose, selectedItem, onSave }) => {
  const [form, setForm] = useState({
    itineraryTimeIn: "",
    itineraryTimeOut: "",
    itineraryLocation: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedItem) {
      setForm({ ...selectedItem });
    } else {
      setForm({ itineraryTimeIn: "", itineraryTimeOut: "", itineraryLocation: "" });
    }
    setErrors({});
  }, [selectedItem, isOpen]);

  const validate = () => {
    let newErrors = {};
    if (!form.itineraryTimeIn) newErrors.itineraryTimeIn = true;
    if (!form.itineraryLocation) newErrors.itineraryLocation = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[11000] bg-black/50 flex items-center justify-center p-3">
      <div className="bg-white w-full md:w-[450px] rounded-lg shadow-xl flex flex-col">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold text-customMainColor">{selectedItem ? "Edit" : "Add"} Itinerary</h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer hover:text-gray-500 transition-colors">
            <CloseIcon />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <Input
            label="Time In"
            type="datetime-local"
            value={form.itineraryTimeIn}
            onChange={(e) => setForm({ ...form, itineraryTimeIn: e.target.value })}
            isRequired
            error={errors.itineraryTimeIn}
          />
          <Input
            label="Time Out"
            type="datetime-local"
            value={form.itineraryTimeOut}
            onChange={(e) => setForm({ ...form, itineraryTimeOut: e.target.value })}
          />
          <Input
            label="Location"
            placeholder="Enter destination/location"
            value={form.itineraryLocation}
            onChange={(e) => setForm({ ...form, itineraryLocation: e.target.value })}
            isRequired
            error={errors.itineraryLocation}
          />
        </div>

        <div className="flex justify-end space-x-2 p-5 border-t bg-gray-50 rounded-b-lg">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded border-none cursor-pointer font-medium">Cancel</button>
          <button
            onClick={() => validate() && onSave(form)}
            className="px-6 py-2 bg-blue-600 text-white rounded border-none cursor-pointer font-bold hover:bg-blue-700 transition-colors"
          >
            {selectedItem ? "Update" : "Add to List"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DTRItineraryAddEditModal;